import { isEmpty } from 'lodash'
import { truncateCollectionName } from '../truncateCollectionName'
import type { I18n } from '@wix/wix-data-client-common-standalone'
import type { PageRef } from '@wix/editor-platform-sdk-types'
import type { PagesToAdd } from '@wix/wix-data-client-common'

export const getCollectionStepTitle = ({
  i18n,
  pagesToAdd,
  collectionName,
}: {
  i18n: I18n
  pagesToAdd: PagesToAdd
  collectionName: string
}) =>
  isEmpty(pagesToAdd)
    ? undefined
    : i18n.t('Adding_Dynamic_Pages_Native_Progress_Bar_Collection_Step_Title', {
        collection_name: truncateCollectionName(collectionName),
      })

const getPageStepTitleKey = ({
  pageKey,
  staticPageRef,
  isEditPage = false,
}: {
  pageKey: string
  staticPageRef?: PageRef
  isEditPage?: boolean
}) => {
  if (staticPageRef) {
    return 'Adding_Dynamic_Pages_Native_Progress_Bar_Static_To_Item_Page_Step_Title'
  }

  return isEditPage
    ? 'addingDynamicPagesNativeProgressBar.editPage.stepTitle'
    : pageKey === 'itemPage'
      ? 'Adding_Dynamic_Pages_Native_Progress_Bar_Item_Page_Step_Title'
      : 'Adding_Dynamic_Pages_Native_Progress_Bar_List_Page_Step_Title'
}

export const getPageStepTitle = ({
  i18n,
  pageKey,
  staticPageRef,
  isEditPage = false,
}: {
  i18n: I18n
  pageKey: string
  staticPageRef?: PageRef
  isEditPage?: boolean
}) => {
  const stepTitleKey = getPageStepTitleKey({
    pageKey,
    staticPageRef,
    isEditPage,
  })

  return i18n.t(stepTitleKey)
}
